/**
 * Модерируемый чат матча — ежедневный ИИ-матч на проде (isAiMatch).
 *
 * В отличие от чата локальных матчей агентов (src/utils/chat/chatMessage.js,
 * немодерируемый, предел 2000 символов), здесь пишут живые игроки и ИИ-агент
 * на продакшене, а каждое сообщение до доставки проверяет агент-модератор
 * через серверную очередь (src/utils/chat/chatModerationQueue.js). Отсюда
 * строгие лимиты: короткие сообщения, редкая отправка и не больше трех
 * сообщений одного автора на проверке — иначе один игрок завалит очередь,
 * а модератор не успеет за всеми.
 *
 * Конфиг общий для сервера (очередь, лимиты, сторож паузы), клиента (поле
 * ввода, кулдаун, текст отказа) и MCP (send_chat_message ждет вердикт).
 */

// Предельная длина одного сообщения в символах (после обрезки пробелов по краям)
export const MODERATED_CHAT_MAX_LENGTH = 500;

// Не чаще одного сообщения в 4 с от одного автора
export const MODERATED_CHAT_MIN_INTERVAL_MS = 4000;
// И не больше 8 сообщений за скользящую минуту
export const MODERATED_CHAT_MAX_PER_MINUTE = 8;
// Окно, в котором считается MODERATED_CHAT_MAX_PER_MINUTE
export const MODERATED_CHAT_RATE_WINDOW_MS = 60000;
// Не больше 3 сообщений одного автора одновременно на проверке
export const MODERATED_CHAT_MAX_PENDING = 3;

// Сколько модератор держит выданное ему сообщение. Не успел вынести вердикт —
// сообщение возвращается в очередь и уходит следующему опросу (модератор мог
// упасть посреди проверки)
export const CHAT_MODERATION_LEASE_MS = 60000;
// Сообщение на проверке дольше этого срока — отказ «модератор не ответил»:
// отправитель не должен ждать вечно, а запоздалое сообщение уже не к месту
export const CHAT_MODERATION_TIMEOUT_MS = 90000;
// Модератор не опрашивал очередь дольше этого срока — чат на паузе, игра идет
export const CHAT_MODERATOR_UNAVAILABLE_MS = 90000;
// Причина отказа от модератора видна отправителю — длинную обрезаем: ее пишет
// агент, читающий недоверенный чат, и раздувать ее нельзя
export const CHAT_MODERATOR_REASON_MAX_LENGTH = 200;

/**
 * Почему сообщение не доставлено. Значение уходит отправителю в
 * CHAT_MESSAGE_REJECTED.reason, текст для игрока подбирает клиент.
 */
export const CHAT_REJECTION_REASONS = {
  // Модератор отклонил (его пояснение — отдельно, в moderatorReason)
  MODERATION_REJECTED: 'moderation_rejected',
  // Модератор недоступен, чат на паузе
  CHAT_PAUSED: 'chat_paused',
  // Слишком часто или слишком много сообщений на проверке
  RATE_LIMITED: 'rate_limited',
  // Модератор не вынес вердикт за CHAT_MODERATION_TIMEOUT_MS
  MODERATION_TIMEOUT: 'moderation_timeout',
  // Пустое, слишком длинное, не строка или со служебными символами
  INVALID: 'invalid',
  // Ссылка — отсекается до модератора
  PREFILTER_LINK: 'prefilter_link',
  // Похоже на ключ, токен или секрет — отсекается до модератора
  PREFILTER_SECRET: 'prefilter_secret',
};
